<div class="i-page-top">
  <div class="container">
    <!--Menu-->
    <div class="i-menu row align-items-center pt-3 pb-2">
      <div class="navbar-brand col-6 col-sm-8 col-md-6 col-lg-4 mr-auto py-2 px-2 text-center text-sm-left">
        <a href="#" routerLink="/home" aria-label="Private"
          ><img src="assets/img/logo_cinza.svg" class="img-fluid my-auto" alt="Private"
        /></a>
      </div>
      <div class="col-6 col-sm-4 col-md-6 col-lg-8 ml-auto py-2">
        <app-menu></app-menu>
      </div>
    </div>
  </div>
</div>
<div class="i-page-content">
  <div class="container pt-3">
    <div class="col-12 text-center py-5">
      <h1 class="i-title">NOSSOS TELEFONES</h1>
    </div>
    <app-phones></app-phones>
  </div>
  <div class="i-contact container pb-5">
    <div class="row pt-3">
      <div class="col-12 text-center py-5">
        <h1 class="i-title">FORMULÁRIO DE CONTATO</h1>
      </div>
    </div>
    <form (ngSubmit)="onSend()" [formGroup]="fmGroup">
      <div class="form-row px-2 px-lg-5">
        <mat-form-field class="col-12 col-lg-8 mx-auto mb-3 i-text" appearance="fill">
          <mat-label class="i-text">NOME</mat-label>
          <input
            id="form-contact-name"
            matInput
            type="text"
            class="i-text pb-1"
            maxlength="255"
            formControlName="name" />
          <mat-error class="i-text-sm mt-1" *ngIf="fmGroup.get('name').errors?.required"> CAMPO OBRIGATÓRIO </mat-error>
        </mat-form-field>
        <mat-form-field class="col-12 col-lg-8 mx-auto mb-3 mt-1" appearance="fill">
          <mat-label class="i-text">TELEFONE</mat-label>
          <input
            id="form-contact-phone"
            matInput
            type="text"
            class="i-text pb-2"
            placeholder="(00) 0000-00000"
            mask="(00) 0000-0000||(00) 00000-0000"
            minlength="14"
            maxlength="15"
            formControlName="phone"
            autocomplete="off" />
          <mat-hint>(00) 00000-0000</mat-hint>
          <mat-error
            class="i-text-sm mt-1"
            *ngIf="fmGroup.get('phone').errors?.minlength && !fmGroup.get('phone').errors?.required">
            POR FAVOR, INFORME NO MÍNIMO 14 DÍGITOS
          </mat-error>
          <mat-error class="i-text-sm mt-1" *ngIf="fmGroup.get('phone').errors?.phoneSintaxError">
            POR FAVOR, VERIFIQUE O NÚMERO DIGITADO
          </mat-error>
          <mat-error class="i-text-sm mt-1" *ngIf="fmGroup.get('phone').errors?.required">
            CAMPO OBRIGATÓRIO
          </mat-error>
        </mat-form-field>
        <mat-form-field class="col-12 col-lg-8 mx-auto mb-3 mt-1" appearance="fill">
          <mat-label class="i-text">E-MAIL</mat-label>
          <input
            id="form-contact-email"
            matInput
            type="text"
            class="i-text pb-2"
            maxlength="255"
            formControlName="email" />
          <mat-error
            class="i-text-sm mt-1"
            *ngIf="fmGroup.get('email').errors?.email && !fmGroup.get('email').errors?.required">
            POR FAVOR, INFORME UM E-MAIL VÁLIDO
          </mat-error>
          <mat-error class="i-text-sm mt-1" *ngIf="fmGroup.get('email').errors?.required">
            CAMPO OBRIGATÓRIO
          </mat-error>
        </mat-form-field>
        <div class="i-search-bar col-12 col-lg-8 d-flex flex-row mx-auto mb-3 mt-1">
          <mat-form-field class="col-9 pl-0" appearance="fill">
            <mat-label class="i-text">CIDADE</mat-label>
            <input
              id="form-contact-city"
              matInput
              type="text"
              class="i-text pb-2"
              maxlength="255"
              formControlName="city" />
          </mat-form-field>
          <mat-form-field class="col-3 pr-0" appearance="fill">
            <mat-label class="i-text">UF</mat-label>
            <mat-select id="form-contact-state" placeholder="ASSUNTO" formControlName="uf" role="combobox">
              <mat-option *ngFor="let uf of ufs" [value]="uf">{{ uf }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <mat-form-field class="col-12 col-lg-8 mx-auto mb-4 mt-1" appearance="fill">
          <mat-label class="i-text">ASSUNTO</mat-label>
          <mat-select id="form-contact-subject" formControlName="subject" placeholder="ASSUNTO" role="combobox">
            <mat-option *ngFor="let subject of subjects" [value]="subject">{{ subject }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="col-12 col-lg-8 mx-auto mb-4 mt-1" appearance="fill">
          <mat-label class="i-text">MENSAGEM</mat-label>
          <textarea
            id="form-contact-message"
            matInput
            type="text"
            class="i-text pb-2"
            #input
            maxlength="500"
            rows="5"
            formControlName="message"></textarea>
          <mat-hint align="end">{{ input?.value?.length || 0 }}/500</mat-hint>
          <mat-error class="i-text-sm mt-1" *ngIf="fmGroup.get('message').errors?.required">
            CAMPO OBRIGATÓRIO
          </mat-error>
        </mat-form-field>
        <!--HR-Buttons-->
        <!--<div *ngIf="hr" class="col-12 col-lg-8 my-2 mx-auto">
                    <div class="i-hr-btn text-center mx-auto">
                        <label for="resume" class="pt-2">ANEXAR CURRÍCULO</label>
                        <input type="file" id="resume" placeholder="ANEXAR CURRÍCULO" />
                    </div>
                </div>-->
      </div>
      <!--Button-->
      <div class="my-3 text-center"><button id="form-contact-submit" type="submit" class="i-btn">ENVIAR</button></div>
    </form>
    <!--Address-->
    <div class="row px-2 px-lg-5 pt-4">
      <div class="i-text col-12 col-lg-8 mx-auto py-5">
        <div class="row">
          <div class="i-address col-12 col-lg-4 mb-5 pl-2 pl-lg-0">
            PORTO ALEGRE
            <br /><br />
            <span>
              Rua 24 de Outubro, 1440<br />
              sala 1605<br />
              Bairro Auxiliadora<br />
              Porto Alegre, RS<br />
              CEP 90510-001<br />
              CRECI 22889-J
            </span>
          </div>
          <div class="i-map col-12 col-lg-8 p-0">
            <a href="#" data-toggle="modal" data-target=".i-map-lightbox" aria-label="Mapa" (click)="onMapOpen('poa')">
              <picture>
                <source type="image/webp" lazyLoad="assets/img/mapa_poa.webp" />
                <img
                  class="img-fluid mx-auto"
                  lazyLoad="assets/img/mapa_poa.png"
                  alt="Mapa de localização Private POA" />
              </picture>
              <!-- Lightbox -->
              <div
                class="modal fade i-map-lightbox"
                tabindex="-1"
                role="dialog"
                aria-labelledby="mapLightbox"
                aria-hidden="true">
                <div class="modal-dialog modal-lg">
                  <div class="modal-content">
                    <picture>
                      <source type="image/webp" srcset="assets/img/mapa_poa_zoom.webp" />
                      <img
                        class="img-fluid mx-auto"
                        src="assets/img/mapa_poa_zoom.png"
                        alt="Mapa de localização Private POA" />
                    </picture>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="row pt-5">
          <div class="i-address col-12 col-lg-4 mb-5 pl-2 pl-lg-0">
            SÃO PAULO
            <br /><br />
            <span>
              R. Dr. Fernandes Coelho, 85<br />
              9 andar<br />
              Bairro Pinheiros<br />
              São Paulo, SP<br />
              CEP 05423-040<br />
              <!-- Av. Cidade Jardim, 400<br />
              Edifício Dacon<br />
              Bairro Itaim Bibi<br />
              São Paulo, SP<br />
              CEP 01454-901<br /> -->
              CRECI 39391-J
            </span>
          </div>
          <div class="i-map col-12 col-lg-8 p-0">
            <a
              href="#"
              data-toggle="modal"
              data-target=".i-map-sp-lightbox"
              aria-label="Mapa"
              (click)="onMapOpen('sp')">
              <!-- <img class="img-fluid mx-auto" src="assets/img/mapa_sp.png"
                                alt="Mapa de localização Private SP" /> -->
              <picture>
                <source type="image/webp" lazyLoad="assets/img/mapa_sp.webp" />
                <img class="img-fluid mx-auto" lazyLoad="assets/img/mapa_sp.png" alt="Mapa de localização Private SP" />
              </picture>
              <!-- Lightbox -->
              <div
                class="modal fade i-map-sp-lightbox"
                tabindex="-1"
                role="dialog"
                aria-labelledby="mapLightbox"
                aria-hidden="true">
                <div class="modal-dialog modal-lg">
                  <div class="modal-content">
                    <picture>
                      <source type="image/webp" srcset="assets/img/mapa_sp_zoom.webp" />
                      <img
                        class="img-fluid mx-auto"
                        src="assets/img/mapa_sp_zoom.png"
                        alt="Mapa de localização Private SP" />
                    </picture>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
